import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function ManufacturingOperation() {
  return (
    <>
<Features docname="Manufacturing Operations"/>
<Advantages docname="Manufacturing Operations"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default ManufacturingOperation;
